import React from 'react';
import { SliderProps } from './Slider.types';
import * as RadixSlider from '@radix-ui/react-slider';

/**
 * Slider .
 */
export const Slider: React.FunctionComponent<SliderProps> = (props) => {
  const {
    onValueChange,
    onPointerUp,
    id,
    value,
    name,
    disabled = false,
    rootExtraClassNames = '',
    trackExtraClassNames = '',
    rangeExtraClassNames = '',
    thumbExtraClassNames = '',
    step,
    min,
    max,
  } = props;

  return (
    <RadixSlider.Root
      className={`tw:relative tw:flex tw:h-5 tw:w-full tw:touch-none tw:select-none tw:items-center ${rootExtraClassNames}`}
      defaultValue={[value]}
      value={[value]}
      onValueChange={(value) => onValueChange && onValueChange(value)}
      onPointerUp={(e) => onPointerUp && onPointerUp(e)}
      name={name}
      id={id}
      max={max}
      min={min}
      disabled={disabled}
      step={step}>
      <RadixSlider.Track
        className={`tw:relative tw:h-sq-5 tw:grow tw:rounded-sm tw:bg-sq-dark-gray tw:dark:bg-sq-dark-disabled-gray ${trackExtraClassNames}`}>
        <RadixSlider.Range className={`tw:absolute tw:h-full tw:rounded-full ${rangeExtraClassNames}`} />
      </RadixSlider.Track>
      <RadixSlider.Thumb
        className={`tw:block tw:h-sq-15 tw:w-sq-15 tw:rounded-full tw:bg-sq-theme-dark tw:active:bg-sq-theme-darker tw:focus:outline-none tw:focus-visible:outline-none tw:aria-disabled:bg-sq-dark-gray tw:dark:aria-disabled:bg-sq-dark-disabled-gray tw:transition tw:ease-in-out ${thumbExtraClassNames}`}
        aria-disabled={disabled}
      />
    </RadixSlider.Root>
  );
};
